import { createMultiNavigation } from '@meterup/react-router-extensions';

export const Nav = createMultiNavigation('drawer');
